import React from 'react';
import { ErrorBoundary, Provider } from '@rollbar/react';
import { rollbar } from './instance';

interface IProps {
  children: React.ReactNode;
}

const RollbarProvider: React.FC<IProps> = (props) => {
  const { children } = props;
  return rollbar ? (
    <Provider instance={rollbar}>
      <ErrorBoundary>{children}</ErrorBoundary>
    </Provider>
  ) : (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{children}</>
  );
};

export default RollbarProvider;
